import { lookupValidator } from 'validated-changeset';

export default lookupValidator;
